export const register = (editor: any) => {
  editor.addButton('alignmentsplit', {
    type: 'listbox',
    text: '',
    tooltip: 'Alignment',
    icon: 'alignleft',
    menu: [
      {
        value: 'alignleft',
        icon: 'alignleft',
        text: 'Align Left',
        onclick() {
          editor.execCommand('JustifyLeft');
        },
      },
      {
        value: 'alignright',
        icon: 'alignright',
        text: 'Align Right',
        onclick() {
          editor.execCommand('JustifyRight');
        },
      },
      {
        value: 'aligncenter',
        icon: 'aligncenter',
        text: 'Align Center',
        onclick() {
          editor.execCommand('JustifyCenter');
        },
      },
      {
        value: 'alignjustify',
        icon: 'alignjustify',
        text: 'Justify',
        onclick() {
          editor.execCommand('JustifyFull');
        },
      },
    ],
    onselect() {
      this.value('');
    },
    onPostRender() {
      const self = this;
      editor.on('nodeChange', () => {
        const { formatter } = editor;
        let value = 'alignleft';
        if (formatter.match('alignright')) {
          value = 'alignright';
        } else if (formatter.match('aligncenter')) {
          value = 'aligncenter';
        } else if (formatter.match('alignjustify')) {
          value = 'alignjustify';
        }

        self.icon(value);
      });
    },
  });
};
